import Vue from 'vue';
import App from './components/App';
import router from './router';
import store from './store';
import VueClipboard from 'vue-clipboard2';

import 'bootstrap/dist/css/bootstrap-reboot.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import '../assets/main.scss';
import '@wl/styles.scss';

/** add library for copying to clipboard **/
Vue.use(VueClipboard);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
